// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"e8273edf","453":"3ac60e2c"}[chunkId] + ".chunk.js";
};